import { transition } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.a `
  ${transition('background-color')};
  text-decoration: none;
  display: block;
  border-bottom: 1px solid var(--fgColour);
  background-color: var(--bgColour);
  padding: ${fluid(10, 20)} 0;
  position: relative;
  color: var(--fgColour);

  &:focus {
    outline: auto;
    outline-offset: 3px;
  }
`;
const ContentArea = styled.div `
  max-width: 800px;
`;
const Title = styled.h3 `
  ${paragraphLarge};
  ${transition('text-decoration-color')};

  position: relative;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 2px;
  margin: 0;
  padding-right: ${fluid(22, 32)};

  ${Container}:hover &,
  ${Container}:focus & {
    text-decoration-color: currentColor;
  }
`;
const Description = styled.div `
  ${fonts.graphikCompact.regular}
  font-size: ${fluid(16, 20)};
  line-height: ${fluid(24, 30)};
  margin: ${fluid(8, 12)} 0 0;
`;
const IconHolder = styled.div `
  position: absolute;
  top: 16px;
  right: 0;

  svg {
    height: ${fluid(20, 27)};

    .download_svg__arrow {
      ${transition('transform')};
    }
  }

  ${Container}:hover &,
  ${Container}:focus & {
    svg .download_svg__arrow {
      transform: translateY(3px);
    }
  }
`;
const DownloadCardStyles = {
    Container,
    ContentArea,
    Description,
    IconHolder,
    Title,
};
export default DownloadCardStyles;
